var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"disable-resize-watcher":"","color":"cyan"}},[_c('v-app-bar-nav-icon'),_c('v-toolbar-title',[_vm._v(_vm._s(this.$route.name))]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("mdi-magnify")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }